import { DeleteOutlined } from "@ant-design/icons";
import { Button, Card, Space, Typography } from "antd";

const { Text } = Typography;

/**
 *
 * Component renders a list of editable templates of type file
 */
const FileRender = ({ fileTemplates, onRemove, isEditable }) => {
  return (
    <>
      {fileTemplates?.map((template) => (
        <FileTemplateEditorWrapper
          key={template.layout_index}
          fileTemplate={template}
          onRemove={onRemove}
          isEditable={isEditable}
        />
      ))}
    </>
  );
};

// receives an editable template which contains a file
const FileTemplateEditorWrapper = ({ fileTemplate, onRemove, isEditable }) => {
  const cardActions = [];
  cardActions.push(
    <Button
      key="delete"
      name="Delete"
      type="primary"
      icon={<DeleteOutlined />}
      onClick={() => {
        onRemove(fileTemplate.layout_index);
      }}
      disabled={!isEditable}
    />
  );

  return (
    <Card
      size="small"
      title={fileTemplate.name}
      extra={cardActions}
      style={{ marginBottom: 10 }}
    >
      <Space orientation="vertical" size="middle">
        <Text>{fileTemplate.description}</Text>
      </Space>
    </Card>
  );
};

export default FileRender;
